import { v4 as uuidv4 } from "uuid";

export default {
    computed: {},
    methods: {
        /**
         * It gets the albums by email
         */
        async getAlbumsByEmail() {
            try {
                this.$store.dispatch("setLoading", true);
                /* Creating an object with the parameters to send to the API. */
                const emailUser = this.$store.state.email;
                const parameters = {
                    type: 3,
                    params: { Email: emailUser },
                };
                /* Calling the API to get the albums by email. */
                const response = await this.$store.dispatch(
                    "getAlbums",
                    parameters
                );
                
                if (!response.length) {
                    this.$store.dispatch("setLoading", false);
                    return;
                }
                // Verificamos si existen codigos de descarga ya cargados
                if (response[0].PhotoExperiences.length) {
                    this.$store.dispatch("deleteDownloadCodesInAlbums");
                }
                /* Calling the function `formatAlbumsByEmail` and passing in the response from the API. */
                this.formatAlbumsByEmail(response);

                /* A method that is used to show a loading icon on the screen. */
                this.$store.dispatch("setLoading", false);
                
                /* Checking if the response from the API has data. If it does, it will redirect the
                user to the `albumes` route. */
                if (this.$route.name == "albumes") {
                    Vue.$toast.open({
                        message: this.$t("messages.album_add_successfully"),
                        type: "success",
                    });

                    return;
                }

                this.$router.push({ name: "albumes" });
            } catch (error) {
                this.$store.dispatch("setLoading", false);
                
            }
        },
        /**
         * This function takes in an array of objects, loops through each object, and if the object has
         * a property of Type with a value of 0, it calls the function albumsByDownloadCode and passes
         * in the object
         * @param data - The data that is returned from the API call.
         */
        formatAlbumsByEmail(data) {
            data.forEach((item) => {
                // Download Codes
                if (item.PhotoDetails.Type === 0 && item.PhotoExperiences.length) {
                    /* Calling the function `albumsByDownloadCode` and passing in the object `item`. */
                    this.albumsByDownloadCode(item);
                }
            });
        },
        /**
         * It takes the data from the API and stores it in the Vuex store
         * @param data - The data returned from the API call
         */
        albumsByDownloadCode(data) {
            let album = {};
            const photoDetails = data.PhotoDetails;

            album.uuid = uuidv4();
            album.code = photoDetails.JoinedCode;
            album.park = data.PhotoExperiences;
            album.Type = photoDetails.Type;

            album.getCode = { AvailableParks: photoDetails.AvailableParks, PackageName: this.currentPackage };
            album.selectedParks = photoDetails.SelectedParks;

            // We store the album
            this.$store.dispatch("setAlbum", [album]);
            // We activate the tab to show the codes
            this.$store.dispatch("setDownloadCodeTab", true);
            this.$store.dispatch("setTypeCodeTab", 0);

            
        },
    },
};
